<template>
  <section class="page-hero">
    <TvaBackgroundVideo
      class="page-hero__video"
      :pathToVideo="`${currentPage}_${i18n.locale.value}-0`"
      autoPlay
    />
    <PageHeroContent
      class="page-hero__content"
      :currentPage="currentPage"
      :title="title"
      :introText="introText"
      :pdfLink="pdfLink"
    />
  </section>
</template>

<script setup>
import { useI18n } from "vue-i18n";

import PageHeroContent from "../general/PageHeroContent.vue";
import TvaBackgroundVideo from "../general/TvaBackgroundVideo.vue";

defineProps({
  currentPage: String,
  title: String,
  introText: String,
  pdfLink: String,
});

const i18n = useI18n();
</script>

<style lang="scss" scoped>
.page-hero {
  width: 100%;
  height: calc(var(--vh) * 100);
  background-color: var(--page-color);

  .desktop &,
  .large & {
    padding: 0 var(--page-padding-h);
  }

  .mobile &,
  .padding & {
    @include home-side-stripes;
  }

  &__content {
    .desktop &,
    .large & {
      width: var(--left-space);
    }
  }

  &__video {
    top: 0;

    ::v-deep(video) {
      // left: calc(var(--page-padding-h) + var(--left-space));
      // transform: translateY(-50%);
    }

    .desktop &,
    .large & {
      left: calc(var(--page-padding-h) + var(--left-space));
      width: calc(100% - var(--page-padding-h) * 2 - var(--left-space));
      height: calc(var(--vh) * 100);
      // clip-path: polygon(41.5% 0, 85% 0%, 85% 100%, 41.5% 100%);
    }

    .mobile &,
    .tablet & {
      position: relative;
      left: 0;
      height: 50%;

      ::v-deep(video) {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
